import React from 'react';
import useChangelog from '../hooks/useChangelog';
import { NLink } from '@innersource-nn/novoui-react';

const SystemUpdates: React.FC = () => {
    const changelog = useChangelog();
    const [showMore, setShowMore] = React.useState<boolean>(false);

    return (
        <div className="font-light">
            <h2 className="notification-section-title">System updates</h2>
            {changelog.map(
                (version, index) =>
                    // we want to add this to allow flexiblity to show 1 or more versions whenever we want to
                    (index === 0 || showMore) && (
                        <div
                            key={version.versionNumber} // Using version number as the key
                            className="bg-white rounded-8 mt-16 text-sm text-true-blue p-24 shadow-md"
                        >
                            <b className="text-xl font-bold">
                                Changelog version {version.versionNumber}
                            </b>
                            <div>
                                {version.content.map(
                                    (section, sectionIndex) => (
                                        <div
                                            className="my-8"
                                            key={`${version.versionNumber}-${sectionIndex}`}
                                        >
                                            <h3 className="my-8 font-bold">
                                                {section.heading}
                                            </h3>
                                            <ul className="list-inside list-disc">
                                                {section.listItems.map(
                                                    (item, itemIndex) =>
                                                        item.subtitle === '' ? (
                                                            <p
                                                                key={`${version.versionNumber}-${sectionIndex}-${itemIndex}`}
                                                            >
                                                                {item.text}
                                                            </p>
                                                        ) : (
                                                            <li
                                                                className="my-4"
                                                                key={`${version.versionNumber}-${sectionIndex}-${itemIndex}`}
                                                            >
                                                                {item.subtitle}:{' '}
                                                                {item.text}
                                                            </li>
                                                        ),
                                                )}
                                            </ul>
                                        </div>
                                    ),
                                )}
                            </div>
                        </div>
                    ),
            )}

            <div className="mt-16">
                <NLink href="#" onClick={() => setShowMore(!showMore)}>
                    {!showMore && <span>Show previous updates</span>}
                    {showMore && <span>Hide previous updates</span>}
                </NLink>
            </div>
        </div>
    );
};

export default SystemUpdates;
